module.exports = __webpack_public_path__ + "content/themes/randstad-human-forward/dist/randy/img/randy.e58c4827.png";